import { createTheme } from '@mui/material/styles';
import { palette, typography, components, spacing } from './theme-variables';
import { effects } from './tokens/semantic';

// Base theme provides breakpoints for responsive typography
const baseTheme = createTheme();

const theme = createTheme({
    palette,
    spacing,
    typography: typography({ theme: baseTheme }),
    components,

    // Custom design system properties directly from semantic/foundation tokens
    border: effects.border,
    radius: effects.radius,
    shadow: effects.shadow,
});

export default theme;